import Button from 'components/button/Button';
import usePropertiesUpdatingAllowed from 'components/domain/property/usePropertiesUpdatingAllowed';
import { useTranslation } from 'react-i18next';
import { Link, useParams } from 'react-router-dom';
import PropertyEditActionWrapper from '../common/PropertyEditActionWrapper';
import usePropertyOwners from './usePropertyOwners';

const PropertySettingsOwnersTabHeader = () => {
  const propertiesUpdatingAllowed = usePropertiesUpdatingAllowed();
  const { t } = useTranslation();
  const { uid } = useParams();
  const propertyUid = uid as string;
  const { data, isLoading } = usePropertyOwners({
    propertyUid,
    enabled: !!propertyUid,
  });

  const hasNoOwner = data?.propertyOwnership?.owner === null;

  if (isLoading || hasNoOwner) {
    return null;
  }

  return (
    <PropertyEditActionWrapper tooltipId="manage-owner-adjustments-link-tooltip">
      <Link
        to={`/owner-adjustments/${propertyUid}`}
        data-testid="manage-owner-adjustments-link"
        target="_blank"
      >
        <Button
          $colorScheme="green"
          data-testid="manage-owner-adjustments-button"
          disabled={!propertiesUpdatingAllowed}
        >
          {t('pageProperty.owners.manageOwnerAdjustments')}
        </Button>
      </Link>
    </PropertyEditActionWrapper>
  );
};

export default PropertySettingsOwnersTabHeader;
